import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { Box, Button, Card, CircularProgress, Container, Grid, IconButton, LinearProgress, Typography } from "@mui/material";
import { Call, CloseOutlined, GraphicEq, Home, PlayArrow, PlayArrowRounded, Telegram, WhatsApp } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import { authActions } from '../../store/reducer/auth-reducer';
import { homePageActions } from '../../store/reducer/home';
import { useNavigate } from 'react-router-dom';
import AlertBar from '../../components/AlertBar';
import { isEmpty } from 'lodash';
import { starlineActions } from '../../store/reducer/starline';
import { ReactComponent as PlayIcon } from '../../assets/play-square-svgrepo-com.svg';
import { ReactComponent as OpenIcon } from '../../assets/check-square-svgrepo-com.svg';
import { ReactComponent as CloseIcon } from '../../assets/close-square-svgrepo-com.svg';
import { ReactComponent as TimerIcon } from '../../assets/timer-start-svgrepo-com.svg';
import { ReactComponent as ContactUs } from '../../assets/support-svgrepo-com.svg';
import { ReactComponent as AddFundIcon } from '../../assets/wallet-receive-svgrepo-com.svg';
import { ReactComponent as WithdrawFundIcon } from '../../assets/wallet-send-svgrepo-com.svg';
import { ReactComponent as InfoIcon } from '../../assets/info-square-svgrepo-com.svg';
import CustomModal from '../../components/CustomModal';

const StarLine = ({ isStarLineLoading, starLineData, isStarLineDataFailed, starLineMsg }: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession)

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState<any>([])

    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [selectedItem, setSelectedItem] = useState<any>({});
    const [openModal, setOpenModal] = useState<any>(false);

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(starlineActions.starLineDataReq(data))
        const pay: any = {
            menuname: 'starline'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    useEffect(() => {
        if (!isEmpty(starLineData)) {
            setPageData(starLineData.result)
        }
    }, [starLineData, isStarLineLoading])

    const handleCardClick = (event: any, item: any) => {
        setSelectedItem(item);

        if (item.msg_status === 1) {
            navigate('/starline/game-list/' + item.game_id)
        } else {
            setErrorMessage({ status: true, message: "Game is closed for today.", severity: 'error', inputName: '' })
        }
    }



    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    // const colorList: any = {
    //     1: '#ffce85', 2: '#fb9090', 3: '#dcdcf9', 4: '#69b9f9', 5: '#61cdc3', 6: '#ffdacc', 7: '#fbbfa8', 8: '#f9b69c', 9: '#d9efff', 10: '#cae7fb', 11: '#b9e2fd', 12: '#fbe5ff', 13: '#fae0ff', 14: '#f8d5ff', 15: '',
    // }

    const colorList: any = {
        1: '#f7ae2b', 2: '#fb9090', 3: '#dcdcf9', 4: '#69b9f9', 5: '#61cdc3', 6: '#ffdacc', 7: '#ffdacc', 8: '#ffdacc', 9: '#ffdacc', 10: '#ffdacc', 11: '#ffdacc', 12: '#ffdacc', 13: '#ffdacc', 14: '#ffdacc', 15: '',
    }

    const openLoginCheckPages = (type: any) => {
        if (isEmpty(finalData)) {
            setErrorMessage({ status: true, message: "Login required.", severity: "warning", inputName: '' })
        } else {
            if (type === 'addpoints') {
                navigate('/add-point')
            } else {
                navigate('/withdraw-points')
            }
        }

    }

    const openPopup = () => {
        console.log('called')
        setOpenModal(true)
    }

    const closePopup = () => {
        setOpenModal(false)
    }

    return (
        <div>
            {isStarLineLoading ? <div style={{ width: '100%', height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress /> </div> :
                <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', paddingTop: '0px !important', position: 'absolute', marginTop: '0px', height: 'calc(100vh - 200px)', overflowY: 'scroll' }} >

                    <Grid container sx={{
                        display: 'flex', justifyContent: 'flex-start', padding: '24px', marginBottom: {
                            xs: '45px',
                            lg: 0,
                            md: 0,
                            xl: 0,
                            sm: '45px',
                        }
                    }}>


                        {(pageData.length) ? pageData.map((item: any, index: number) => (
                            <Grid xs={12} lg={3} md={4} sm={4} margin={1} >
                                <Card variant="outlined"
                                    onClick={(event: any) => handleCardClick(event, item)}
                                    sx={{
                                        borderRadius: '22px', boxShadow: '0px 0px 2px #adadad27',
                                        border: '0px solid transparent', padding: '10px', backgroundColor: '#ffff',

                                    }}>
                                    <Box sx={{ display: 'flex', color: (item.msg_status === 1) ? '#5d5d5d' : '#5d5d5d', padding: '10px 5px 10px 5px', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                        
                                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0px 8px 0px 8px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: '5px', alignItems: 'flex-start', justifyContent: 'flex-start'  }}>
                                                <Typography sx={{ textAlign: 'left', color: 'inherit',fontFamily: 'calibri', fontSize: '1.3rem', fontWeight: '800', lineHeight: 1 }}>
                                                    {item.game_name}
                                                </Typography>
                                                <Typography sx={{marginTop:'5px',  textAlign: 'center', color: '#f7ae2b', fontFamily: 'calibri', fontSize: '1.5rem', fontWeight: '800', lineHeight: 1 }}>
                                                    {(item.open_result != '') ? item.open_result.replace('0', '0') : '***-*'}{(item.close_result != '') ? item.close_result.replace('0', '0') : ''}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ marginTop:'5px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Typography sx={{ color: 'inherit', fontFamily: 'calibri', fontSize: '0.8rem', fontWeight: '400', lineHeight: 1 }}>
                                                          Result Time
                                                    </Typography>
                                                </Box>
                                            <Box sx={{marginTop:'5px',  display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography sx={{ color: 'inherit', fontFamily: 'calibri', fontSize: '0.8rem', fontWeight: '400', lineHeight: 1 }}>
                                                    {item.open_time}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        
                                        <IconButton sx={{
                                                borderRadius: '18px', height: '100px', width: '100px', padding: 0,
                                                display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', boxShadow: '0px 0px 0px #adadad27'
                                            }}>
                                                {(item.msg_status === 1) ? <Typography sx={{ fontSize: '8px', color: 'green', marginBottom: '5px' }}>Open</Typography> : <Typography sx={{ fontSize: '9px', color: 'red', marginBottom: '2px' }}>Closed for today</Typography>}
                                                {item.msg_status == 1 ? <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'40px', width:'40px', borderRadius:'30px', backgroundColor:'#f8b12a'}}><PlayArrowRounded sx={{fontSize:'2rem'}}/> </div> : <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'40px', width:'40px', borderRadius:'30px', backgroundColor:'#f8b12a'}}><PlayArrowRounded sx={{fontSize:'2rem'}}/> </div> }
                                                <Typography sx={{ fontSize: '8px', color: '#5d5d5d', marginBottom: '0px', marginTop:'5px' }}>Play game</Typography>
                                            </IconButton>                                     
                                    </Box>
                                </Card>
                            </Grid>
                        )) : ''}

                    </Grid>
                    <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                    <CustomModal open={openModal} customstyle={{ width: '200px', backgroundColor: '#FFF', padding: '16px' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography sx={{ fontSize: '14px', color: '#f7ae2b', }}>Contact us</Typography>
                            <CloseOutlined onClick={closePopup} sx={{ cursor: 'pointer', textAlign: 'right', color: '#f7ae2b', height: '20px', width: '20px' }} />
                        </Box>

                        <Box sx={{
                            display: 'flex', marginTop: '10px', bottom: 0, justifyContent: 'center', alignItems: 'center', marginBottom: '20px', gap: 2,
                            backgroundColor: '#eeeeee',
                            padding: '10px',
                            borderRadius: '20px',
                            color: '#f7ae2b',
                        }}>
                            <WhatsApp sx={{ cursor: 'pointer' }} onClick={() => alert('link bhej de')} />
                            <Telegram sx={{ cursor: 'pointer' }} onClick={() => alert('link bhej de')} />
                            <Call sx={{ cursor: 'pointer' }} onClick={() => alert('Laga doonga')} />
                        </Box>
                    </CustomModal>
                </Container>}

        </div>
    )
}

const mapStateToProps = (state: any) => ({
    isStarLineLoading: state.starline.isStarLineLoading,
    starLineData: state.starline.starLineData,
    isStarLineDataFailed: state.starline.isStarLineDataFailed,
    starLineMsg: state.starline.starLineMsg,
})

export default connect(mapStateToProps)(StarLine);